const chronoTheme = {
    primary: "#880000",
    secondary: "#880000",
    titleColorActive: "#ffffff",
    cardBgColor: "#7a8474aa",
    cardTitleColor: "#000000"
}

export { chronoTheme }